import * as React from 'react';
import ContrastOutlined from './contrast-outlined';
import ContrastFilled from './contrast-filled';
import type { IconCombinedProps } from './types';
const ContrastCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ContrastFilled ref={ref} {...rest} />;
  }
  return <ContrastOutlined ref={ref} {...rest} />;
});
export default ContrastCombined;